module.exports = __webpack_public_path__ + "img/antes_despues_206.a0bc4c54.png";